
import * as React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import _ from "lodash"
function PropertyStructuredDataNewHomes({ property, pageurl }) {
  console.log("darbuka",property,pageurl);
  const cloud_url = process.env.GATSBY_CLOUD_URL;
  const site_url = process.env.GATSBY_SITE_URL; 
  var ldJson = {
    "@context" : "http://schema.org",
    "@type" : "Product",
    "name" : property.development_title,
    "image" : property.images[0]?.url,
    "description" : property.short_description,
    "brand" : {
      "@type" : "Organization",
      "name" : process.env.GATSBY_SITENAME,
      "logo" : site_url+'/images/logo.png'
    },
    "offers": {
          "@type": "Offer",
          "url": pageurl,
          "priceCurrency": "GBP",
          "price": property.max_price,
          "availability": "https://schema.org/InStock"
    }
  }
  return (
    <Helmet>
      <script defer type="application/ld+json">
        {JSON.stringify(ldJson, null, 2)}
      </script>
    </Helmet>
  )
}


export default PropertyStructuredDataNewHomes
